
import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "@/context/LanguageContext";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";

const NotFound: React.FC = () => {
  const { language } = useLanguage();

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      
      <div className="flex-grow flex items-center justify-center">
        <div className="text-center px-4 py-20">
          <h1 className="text-6xl font-bold text-palsustain-green mb-6">404</h1>
          <p className="text-2xl text-palsustain-charcoal/80 mb-8">
            {language === "en" 
              ? "Oops! Page not found" 
              : "عفوا! الصفحة غير موجودة"
            }
          </p>
          <Link 
            to="/" 
            className="px-6 py-3 bg-palsustain-green text-white font-medium rounded-md hover:bg-palsustain-green/90 transition-all duration-300"
          >
            {language === "en" ? "Return to Home" : "العودة إلى الصفحة الرئيسية"}
          </Link>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default NotFound;
